import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';

export default class Footer extends BaseComp.default {
	componentDidMount(){
		super.componentDidMount();
        window.addEventListener('OTConsentApplied', () => location.reload());
    }
}